import { GraphNode } from '../graph-node.js';
/**
 * Terminates a custom-function body and reports the taken exec path plus the
 * current return-port values to the CallFunctionNode.
 */
export class FunctionReturnNode extends GraphNode {
    resolveReturn = null;
    setReturnResolver(resolver) {
        this.resolveReturn = resolver;
    }
    /** A replaced call must no longer continue the caller from a latent path. */
    dispose() {
        this.resolveReturn = null;
    }
    run() {
        const execPortKey = this.enteredExecInPortKey ?? 'exec';
        this.getDataFromInPorts();
        this.resolveReturn?.({ outputs: this.collectReturnValues(), execPortKey });
    }
    collectReturnValues() {
        const outputs = {};
        for (const [key, value] of Object.entries(this.data)) {
            if (key === 'functionId' || this.execInPortKeys.has(key))
                continue;
            outputs[key] = value;
        }
        return outputs;
    }
}
